import { z } from "zod";
import { CustomerId } from "../fsm/fsm.schema.ts";

export const CompletenessCheckId = z.enum([
  "rolesWithPermissions",
  "noEmptyRoleWithUsers",
  "activeUsers",
  "locations",
  "bikes",
]);

export type CompletenessCheckId = z.infer<typeof CompletenessCheckId>;

export const CustomerCompletenessCheck = z.object({
  id: CompletenessCheckId,
  passed: z.boolean(),
  message: z.string(),
  linkPath: z.string().nullable(),
});

export type CustomerCompletenessCheck = z.infer<
  typeof CustomerCompletenessCheck
>;

export const CustomerCompletenessInfo = z.object({
  id: z.literal("fsmWorkflow"),
  present: z.boolean(),
  message: z.string(),
});

export type CustomerCompletenessInfo = z.infer<typeof CustomerCompletenessInfo>;

export const CustomerCompletenessDto = z.object({
  customerId: CustomerId,
  operational: z.boolean(),
  checks: z.array(CustomerCompletenessCheck),
  informational: z.array(CustomerCompletenessInfo),
});

export type CustomerCompletenessDto = z.infer<typeof CustomerCompletenessDto>;
